import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSpinner,
  faCheck,
  faCheckDouble,
} from "@fortawesome/pro-solid-svg-icons";

type DeliveryStatus = "pushed" | "persisted" | "received" | "read";

const ICON_LOOKUP = {
  pushed: faSpinner,
  persisted: faCheck,
  received: faCheckDouble,
  read: faCheckDouble,
};

export default function MessageDeliveryStatus({
  deliveryStatus,
}: {
  deliveryStatus: DeliveryStatus;
}) {
  const icon = ICON_LOOKUP[deliveryStatus];

  if (!icon) return null;

  return (
    <span
      className={`chat__delivery_status chat__delivery_status--${deliveryStatus}`}
      title={I18n.t(
        `js.chat.room.message.meta.delivery_status.${deliveryStatus}.title`,
      )}
    >
      <FontAwesomeIcon
        icon={icon}
        size="sm"
        spin={deliveryStatus === "pushed"}
      />
    </span>
  );
}
